module.exports = __webpack_public_path__ + "static/redot4-e1be636ba0e206eea3132b8afec55174.gif";